// src/client/game/input/mobileControlsSettings.ts

import Phaser from "phaser";

export type MobileControlsMode = "joystick" | "dpad" | "swipe";

const REGISTRY_KEY = "mobileControlsMode";
const LOCALSTORAGE_KEY = "laserSnake.mobileControlsMode";

/**
 * Initialize the mobile-controls mode from local cache.
 */
export function initMobileControlsMode(scene: Phaser.Scene): void {
  const registry = scene.registry;

  const existing = registry.get(REGISTRY_KEY) as MobileControlsMode | undefined;
  if (existing === "joystick" || existing === "dpad" || existing === "swipe") {
    return;
  }

  // Default mode: DPad
  let mode: MobileControlsMode = "dpad";

  // Try localStorage first
  if (typeof window !== "undefined" && window.localStorage) {
    const stored = window.localStorage.getItem(LOCALSTORAGE_KEY);
    if (stored === "joystick" || stored === "dpad" || stored === "swipe") {
      mode = stored;
    }
  }

  registry.set(REGISTRY_KEY, mode);
}

/**
 * Read the current mobile controls mode.
 */
export function getMobileControlsMode(
  scene: Phaser.Scene
): MobileControlsMode {
  const val = scene.registry.get(REGISTRY_KEY) as MobileControlsMode | undefined;
  if (val === "joystick" || val === "dpad" || val === "swipe") return val;
  return "dpad";
}

/**
 * Update and persist the mobile controls mode.
 */
export function setMobileControlsMode(
  scene: Phaser.Scene,
  mode: MobileControlsMode
): void {
  const m: MobileControlsMode =
    mode === "joystick" || mode === "dpad" || mode === "swipe"
      ? mode
      : "dpad";

  scene.registry.set(REGISTRY_KEY, m);

  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.setItem(LOCALSTORAGE_KEY, m);
  }
}
